const SUPPORT_MENU_ITEMS = [
  {
    id: 'video',
    label: 'Video Tutorials',
    image: '/static/img/support-video.png',
    url: 'https://www.youtube.com/channel/UCqzbyXfGVjXe6UWAR3MiF5Q',
    targetBlank: true,
    description: 'Learn how to create and edit MyCanvas projects.',
  },
  {
    id: 'faq',
    label: 'FAQs',
    image: '/static/img/support-faq.png',
    url: 'https://intercom.help/mycanvas/en/',
    targetBlank: true,
    description: 'Advice and answers from the MyCanvas Team.',
  },
  {
    id: 'shipping',
    label: 'Shipping and Returns',
    image: '/static/img/support-shipping.png',
    url: '/shipping',
    targetBlank: false,
    description: 'See our shipping options and rates for your location.',
  },
  {
    id: 'email',
    label: 'Email Us',
    image: '/static/img/support-email.png',
    url: 'mailto:help@mycanvas.com',
    targetBlank: false,
    description: 'Ask us anything or share your feedback.',
  },
];

export default SUPPORT_MENU_ITEMS;
